import React from 'react';

type UploadStatus = 'idle' | 'uploading' | 'success' | 'error' | undefined;

interface FileUploadInputProps {
    name: string;
    label: string;
    fileUrl?: string | null;
    fileName?: string | null;
    isSubmitting: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    progress?: number;
    status?: UploadStatus;
    isRequired?: boolean;
    error?: string;
    accept?: string;
    'data-testid'?: string;
}

const FileUploadInput: React.FC<FileUploadInputProps> = ({
    name,
    label,
    fileUrl,
    fileName,
    isSubmitting,
    onChange,
    progress,
    status,
    isRequired,
    error,
    accept,
    'data-testid': testId,
}) => {
    // Melhor detecção do estado de upload
    const isUploading = status === 'uploading' || (progress !== undefined && progress >= 0 && progress < 100 && !fileUrl);
    const isSuccess = fileUrl || status === 'success';

    return (
        <div data-testid={testId}>
            <label htmlFor={name} className="block text-sm font-medium text-gray-700">
                {label} {isRequired && <span className="text-red-500">*</span>}
            </label>
            {isUploading ? (
                <div className="mt-1">
                    <div className="w-full bg-gray-200 rounded-full h-2.5" role="progressbar" aria-valuenow={progress || 0} aria-valuemin={0} aria-valuemax={100}>
                        <div
                            className="bg-indigo-600 h-2.5 rounded-full transition-all duration-300"
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>
                    <p className="text-sm text-gray-500 mt-1 text-center">{Math.round(progress || 0)}%</p>
                </div>
            ) : isSuccess ? (
                <div className="mt-1 flex items-center justify-between text-sm border rounded-md p-2 bg-gray-50">
                    <p className="text-gray-900 truncate pr-4">{fileName || 'Documento salvo.'}</p>
                    <div className="flex-shrink-0 space-x-2">
                        <a href={fileUrl!} target="_blank" rel="noopener noreferrer" className="font-medium text-indigo-600 hover:text-indigo-500">Visualizar</a>
                        <span className="text-gray-300" aria-hidden="true">|</span>
                        <label htmlFor={name} className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500">Substituir</label>
                        <input id={name} name={name} type="file" accept={accept} onChange={onChange} disabled={isSubmitting} className="hidden" />
                    </div>
                </div>
            ) : (
                <div className="mt-1">
                    <input
                        id={name}
                        name={name}
                        type="file"
                        accept={accept}
                        onChange={onChange}
                        disabled={isSubmitting}
                        className={`block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 ${error ? 'border-red-500 rounded-lg border p-1.5' : ''}`}
                    />
                </div>
            )}
            {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>
    );
};

export default FileUploadInput; 
